import { type LucideIcon } from "lucide-react"
import { NavLink, useLocation } from "react-router-dom"

import {
  SidebarGroup,
  SidebarGroupLabel,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
} from "@/components/ui/sidebar"

export function NavMain({
  items,
  label,
}: {
  items: {
    title: string
    url: string
    icon: LucideIcon
    badge?: string
  }[]
  label?: string
}) {
  const location = useLocation()
  const pathname = location.pathname

  // Only the most specific matching item is active (longest URL that matches).
  // Prevents both "Overview" and "Templates" being active when at /app/outreach/templates.
  const matchingUrl = items
    .filter(
      (item) =>
        pathname === item.url ||
        (item.url !== "/dashboard" && pathname.startsWith(item.url + "/"))
    )
    .sort((a, b) => b.url.length - a.url.length)[0]?.url

  return (
    <SidebarGroup>
      {label && <SidebarGroupLabel>{label}</SidebarGroupLabel>}
      <SidebarMenu>
        {items.map((item) => {
          const isActive = item.url === matchingUrl
          
          return (
            <SidebarMenuItem key={item.title}>
              <SidebarMenuButton 
                asChild 
                isActive={isActive}
                tooltip={item.title}
              >
                <NavLink to={item.url}>
                  <item.icon />
                  <span>{item.title}</span>
                  {item.badge && (
                    <span className="ml-auto rounded-md bg-muted px-2 py-0.5 text-xs text-muted-foreground">
                      {item.badge}
                    </span>
                  )}
                </NavLink>
              </SidebarMenuButton>
            </SidebarMenuItem>
          )
        })}
      </SidebarMenu>
    </SidebarGroup>
  )
}
